import { render } from "./UpdateProfile.vue?vue&type=template&id=ec708586"
import script from "./UpdateProfile.vue?vue&type=script&lang=js"
export * from "./UpdateProfile.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__